import { FunctionComponent } from 'react';
import { twMerge } from 'src/utils/twMerge';
import { projectColors } from 'src/styles/project-styles';

type Props = {
  name?: string;
  className?: string;
};

const CustomAvatar: FunctionComponent<Props> = ({ name = '#', className }) => {
  const getBackgroundColorForName = (): string => {
    const colors = Object.values(projectColors.avatar);

    let hash = 0;
    for (let i = 0, len = name?.length; i < len; i += 1) {
      hash = (hash << 5) - hash + name.charCodeAt(i);
      hash |= 0;
    }
    return colors[Math.abs(hash) % colors.length];
  };

  return (
    <div
      style={{
        backgroundColor: getBackgroundColorForName(),
      }}
      className={twMerge(
        'text-white h-8 w-8 rounded-full flex items-center justify-center text-lg',
        className,
      )}
    >
      <div style={{ lineHeight: '1rem', height: 13 }}>
        {name && name.length > 0 ? name.charAt(0) : '#'}
      </div>
    </div>
  );
};

export default CustomAvatar;
